import SearchInput from './component'
export { SearchInput }
export default SearchInput